<template>
  <div class="content-container tab-container flex-row">
    <TheLoader :active="loading"/>

    <overlay-scrollbars :options="{ className: 'content-container flex-column os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <section class="content large-padding">
        <div class="grid-x align-items-center">
          <div class="cell auto">
            <h2 class="no-margin">Besiktigelsesrapport #{{objekt.Objektnr}} <em class="opacity-60" v-show="this.autosaving"> (autolagring)</em></h2>
          </div>

          <div class="cell shrink">
            <div class="grid-x grid-margin-x">
              <div class="cell shrink">
                <a href="javascript:;" v-if="!isPresenceOwner" class="button primary disabled"><span class="button-title">Lagre</span></a>
                <a href="javascript:;" v-else-if="$store.getters.isFormSubmittable" @click="handleSubmit()" class="button primary initiate-loading"><span class="button-title">Lagre</span></a>
                <a href="javascript:;" v-else-if="$store.getters.isFormProcessing && saveType === 'normal'" class="button primary loading"><span class="button-title">Lagrer</span> <span class="loader-spinner"></span></a>
                <a href="javascript:;" v-else class="button primary disabled"><span class="button-title">Lagre</span></a>
              </div>
              <div class="cell shrink" v-if="item.Objektid && item.Tekst !== ''">
                <a href="javascript:;" v-if="!isPresenceOwner" class="button primary disabled"><span class="button-title">Lagre og skriv ut / send til kunde</span></a>
                <a href="javascript:;" v-else-if="$store.getters.isFormSubmittable" @click="saveAndPrint()" class="button primary initiate-loading"><span class="button-title">Lagre og skriv ut / send til kunde</span></a>
                <a href="javascript:;" v-else-if="$store.getters.isFormProcessing && saveType === 'print'" class="button primary loading"><span class="button-title">Lagre og skriv ut / send til kunde</span> <span class="loader-spinner"></span></a>
                <a href="javascript:;" v-else class="button primary disabled"><span class="button-title">Lagre og skriv ut / send til kunde</span></a>
              </div>
            </div>
          </div>
        </div>

        <div class="card large-padding margin-top no-margin-bottom card-background">
          <div class="cell" style="font-size: 0.9rem; padding-left: 0.2rem;">
            <span v-if="objekt.auksjon">{{objekt.auksjon.Beskrivelse}}, {{objekt.auksjon.Auksjon_dato | avantidate}}</span>
            <span v-else-if="objekt.Auksjon">{{objekt.Auksjon}}</span>
            <br>

            <span v-if="objekt.Katalognr">Kat. {{objekt.Katalognr}}, Antall: {{objekt.Antall}}</span>
            <span v-else>Antall: {{objekt.Antall}}</span>
            <br>
            <span v-if="objekt.kunstner">{{objekt.kunstner.Navn}}, {{objekt.Katalogtekst1}}</span>
            <span v-else-if="objekt.Kunstner">{{objekt.Kunstner}}, {{objekt.Katalogtekst1}}</span>
            <span v-else>{{objekt.Katalogtekst1}}</span>
            <br>
            <span v-if="objekt.Objekt3">{{objekt.Objekt3}}</span>
            <br>
            <span v-if="objekt.Objekt1">{{objekt.Objekt1}}</span>

            <br><br>
          </div>
          <div class="cell">
            <div class="input-container full-height" :class="{'form-error': errors.has('Tekst')}">
              <textarea v-model="form.Tekst" name="Tekst" rows="30" placeholder="Merknad…" v-validate="'required'" :disabled="!isPresenceOwner"></textarea>
              <span class="form-error-label" v-if="errors.has('Tekst')">
                  <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                  {{errors.first('Tekst')}}
                </span>
            </div>
          </div>
        </div>
      </section>
    </overlay-scrollbars>
  </div>
</template>

<script>

const AUTOSAVE_TTL = 15000

export default {
  name: 'KundeKontraktObjektTabBesiktelse',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      autosaveId: null,
      autosaving: false,
      form: {
        Objektid: null,
        Tekst: ''
      },
      saveType: 'normal',
      presenceChannelName: null
    }
  },
  props: {
    objekt: {
      type: Object,
      required: true
    }
  },
  computed: {
    item: function () {
      return this.$store.getters['objektbesikt/item']
    },
    loading: function () {
      return this.$store.getters['objektbesikt/loading']
    },
    isPresenceOwner: function () {
      return this.$store.getters['presence/isOwner'](this.presenceChannelName)
    }
  },
  watch: {
    objekt: function () {
      // Set form not submittable
      this.setFormLoading(true)

      this.$store.dispatch('objektbesikt/get', this.objekt.Objektid)
        .then(() => {
          this.setupForm()
        })
        .catch(() => {
          this.setupForm()
        })
    }
  },
  created () {
    // Set name for the WS channel
    this.presenceChannelName = 'presence-objekt-edit-' + this.objekt.Objektid
  },
  mounted () {
    // Set form not submittable
    this.setFormLoading(true)

    this.$store.dispatch('objektbesikt/get', this.objekt.Objektid)
      .then(() => {
        this.setupForm()
      })
      .catch(() => {
        this.setupForm()
      })
  },
  beforeDestroy: function () {
    this.clearAutosave()

    // Do a save just in case...
    if (!this.autosaving && this.isFormSubmittable()) {
      this.autosave()
    }
  },
  methods: {
    setupForm: function () {
      if (this.item && this.item.Objektid) {
        // Copy kunde to form
        this.form = this._.cloneDeep(this.item)
      } else {
        // Set some data based on logged in user + objekt
        this.form = {
          Objektid: null,
          Tekst: ''
        }

        this.form.Objektid = this.objekt.Objektid
        this.form.Kontraktnr = this.objekt.Kontraktnr
        this.form.Lopenr = this.objekt.Lopenr
      }

      this.setFormLoading(false)
      this.startAutosave()
    },
    clearAutosave: function () {
      if (this.autosaveId) {
        clearInterval(this.autosaveId)
        this.autosaveId = null
      }
    },
    startAutosave: function () {
      this.clearAutosave()
      this.autosaveId = setInterval(this.autosave, AUTOSAVE_TTL)
    },
    autosave: function () {
      if (this.isPresenceOwner && !this.autosaving && this.form.Tekst !== this.item.Tekst) {
        console.log('Autosaving...')
        const vm = this

        this.autosaving = true
        this.saveType = 'normal'
        this.setFormProcessing(true)

        this.$store.dispatch('objektbesikt/save', this.form)
          .then((response) => {
            setTimeout(function () {
              vm.autosaving = false
              vm.setFormProcessing(false)
            }, 1000)
          })
          .catch((error) => {
            console.log('Error', error)
            setTimeout(function () {
              vm.autosaving = false
              vm.setFormProcessing(false)
            }, 1000)
          })
      }
    },

    handleSubmit: function () {
      if (!this.isPresenceOwner) {
        return
      }

      if (!this.isFormSubmittable()) {
        return
      }

      this.saveType = 'normal'
      this.setFormProcessing(true)

      if (this.form.Tekst) {
        this.form.Tekst = this.form.Tekst.trim()
      }

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre besiktigelsesrapport', 'Vennligst korriger feil i skjemaet')
          } else {
            this.$store.dispatch('objektbesikt/save', this.form)
              .then((response) => {
                this.$helpers.showSuccessAlert('Besiktigelsesrapport er lagret')
                this.setFormProcessing(false)
              })
              .catch((error) => {
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                  this.$helpers.showErrorAlert('Kunne ikke lagre besiktigelsesrapport', 'Vennligst korriger feil i skjemaet')
                } else {
                  this.$helpers.showErrorAlert('Kunne ikke lagre besiktigelsesrapport', 'Vennligst prøv igjen', 2500)
                }

                this.setFormProcessing(false)
              })
          }
        })
    },
    saveAndPrint: function () {
      if (!this.isPresenceOwner) {
        return
      }

      if (!this.isFormSubmittable()) {
        return
      }

      this.saveType = 'print'
      this.setFormProcessing(true)

      if (this.form.Tekst) {
        this.form.Tekst = this.form.Tekst.trim()
      }

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre besiktigelsesrapport', 'Vennligst korriger feil i skjemaet')
          } else {
            this.$store.dispatch('objektbesikt/save', this.form)
              .then((response) => {
                this.openModal('kunde-kontrakt-objekt-besiktelse-modal',
                  { objekt: this.objekt, internalWindow: true },
                  'split'
                )
              })
              .catch((error) => {
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                  this.$helpers.showErrorAlert('Kunne ikke lagre besiktigelsesrapport', 'Vennligst korriger feil i skjemaet')
                } else {
                  this.$helpers.showErrorAlert('Kunne ikke lagre besiktigelsesrapport', 'Vennligst prøv igjen', 2500)
                }

                this.setFormProcessing(false)
              })
          }
        })
    },
    print: function () {
      this.openModal('kunde-kontrakt-objekt-besiktelse-modal',
        { objekt: this.objekt, internalWindow: true },
        'split'
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektTabBesiktelse.vue